// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-fW36xC{width:276px;overflow:hidden}.content-fW36xC .title-UJCOdA{color:rgba(6,7,9,.8);justify-content:space-between;align-items:center;width:100%;margin-bottom:16px;font-size:18px;font-weight:600;line-height:24px;display:flex}.content-fW36xC .description-UsbKY1{color:rgba(6,7,9,.5);margin-bottom:16px;font-size:12px;font-weight:400;line-height:16px}.content-fW36xC .table-a61fIQ{color:rgba(6,7,9,.8);font-size:12px;font-weight:400;line-height:16px}.content-fW36xC .icon-ADpZgG{color:#060709;font-size:16px}.row-XTttTK:last-child *{border-bottom:none!important}.icon-wrapper-oAYAHZ{justify-content:center;align-items:center;width:16px;height:16px;display:flex}.icon-cell-wv8evK{width:24px;height:24px;padding:0!important}.cell-column-SkZnro{width:24px!important;min-width:none!important}.mark-column-NhhGMK{width:68px;min-width:none!important;padding-left:0!important;padding-right:0!important}.example-column-bc91UF{padding-left:0!important;padding-right:0!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content-fW36xC`,
	"title": `title-UJCOdA`,
	"description": `description-UsbKY1`,
	"table": `table-a61fIQ`,
	"icon": `icon-ADpZgG`,
	"row": `row-XTttTK`,
	"icon-wrapper": `icon-wrapper-oAYAHZ`,
	"iconWrapper": `icon-wrapper-oAYAHZ`,
	"icon-cell": `icon-cell-wv8evK`,
	"iconCell": `icon-cell-wv8evK`,
	"cell-column": `cell-column-SkZnro`,
	"cellColumn": `cell-column-SkZnro`,
	"mark-column": `mark-column-NhhGMK`,
	"markColumn": `mark-column-NhhGMK`,
	"example-column": `example-column-bc91UF`,
	"exampleColumn": `example-column-bc91UF`
};
export default ___CSS_LOADER_EXPORT___;
